import range from './util/range'

export const AGES = range(18, 100).map(t => ({
  label: t,
  value: t.toString()
}))
export const SEXES = [
  {
    translationKey: 'demographics_biological_sex_answer_1',
    value: 'female'
  },
  {
    translationKey: 'demographics_biological_sex_answer_2',
    value: 'male'
  }
]
export const RACES = [
  {
    translationKey: 'demographics_race_ethnicity_answer_1',
    value: 'american_indian'
  },
  {
    translationKey: 'demographics_race_ethnicity_answer_2',
    value: 'asian'
  },
  {
    translationKey: 'demographics_race_ethnicity_answer_3',
    value: 'black'
  },
  {
    translationKey: 'demographics_race_ethnicity_answer_4',
    value: 'hispanic'
  },
  {
    translationKey: 'demographics_race_ethnicity_answer_5',
    value: 'pacific_islander'
  },
  {
    translationKey: 'demographics_race_ethnicity_answer_6',
    value: 'white'
  }
]
export const EDUCATION_LEVELS = [
  {
    translationKey: 'demographics_education_answer_1',
    value: '0-6'
  },
  {
    translationKey: 'demographics_education_answer_2',
    value: '7-9'
  },
  {
    translationKey: 'demographics_education_answer_3',
    value: '10-11'
  },
  {
    translationKey: 'demographics_education_answer_4',
    value: 'HIGHSCHOOL_DEGREE'
  },
  {
    translationKey: 'demographics_education_answer_5',
    value: 'SOME_COLLEGE'
  },
  {
    translationKey: 'demographics_education_answer_6',
    value: 'ASSOCIATES_DEGREE'
  },
  {
    translationKey: 'demographics_education_answer_7',
    value: 'BACHELORS_DEGREE'
  },
  {
    translationKey: 'demographics_education_answer_8',
    value: 'MASTERS_DEGREE'
  },
  {
    translationKey: 'demographics_education_answer_9',
    value: 'PROFESSIONAL_DEGREE'
  },
  {
    translationKey: 'demographics_education_answer_10',
    value: 'DOCTORATE_DEGREE'
  }
]
